import {Entity} from "./entity";
import {merge} from "../common/utils";


export class DynamicEntity extends Entity {

    speed = 1;
    offset = {x: 0, y: 0, z: 0} //Target


    lastMoveAt;

    constructor(uid, type) {
        super(uid, type);

        this.lastMoveAt = Date.now();
    }

    setOffset(data) {
        // console.log(`Setting ${this.uid} offset -`, this);
        this.offset = {
            x: data.position.x,
            y: data.position.y,
            z: data.position.z,
        };

        this.rotation = {
            x: data.rotation.x,
            y: data.rotation.y,
            z: data.rotation.z
        };
    }

    setTarget(data) {
        this.setLastMoveAt();
        return this.setOffset(data);
    }

    clearTarget() {
        this.offset = {x: 0, y: 0, z: 0};
    }

    getTarget() {
        return this.offset;
    }

    hasTarget() {
        return this.offset.x !== 0 || this.offset.y !== 0 || this.offset.z !== 0;
    }

    getAbsolutePosition() {
        return merge(this.position, this.offset)
    }

    getLastMoveAt() {
        return this.lastMoveAt
    }

    setLastMoveAt(d = Date.now()) {
        this.lastMoveAt = d;
    }

    canMove() {
        return true
    }

    setSpeed(speed) {
        this.speed = speed
    }

    getSpeed() {
        return this.speed
    }

    update() {
        super.update();
        this._moveToTarget();
    }


    /**
     * Handles the movement from position -> absolute position & tween between based on speed
     * @private
     */
    _moveToTarget() {
        if (!this.hasTarget())
            return

        let position = this.getPosition()

        // Translate over to the position.
        const posX = position.x;
        const posZ = position.z;
        const newPosX = this.getTarget().x;
        const newPosZ = this.getTarget().z;

        // Set a multiplier just in case we need negative values.
        let multiplierX = 1;
        let multiplierZ = 1;

        // Detect the distance between the current pos and target.
        const diffX = Math.abs(posX - newPosX);
        const diffZ = Math.abs(posZ - newPosZ);
        const distance = Math.sqrt(diffX * diffX + diffZ * diffZ);

        // Use negative multipliers if necessary.
        if (posX > newPosX) {
            multiplierX = -1;
        }

        if (posZ > newPosZ) {
            multiplierZ = -1;
        }

        // Update the main position.
        position.x = position.x + (this.getSpeed() * (diffX / distance)) * multiplierX;
        position.z = position.z + (this.getSpeed() * (diffZ / distance)) * multiplierZ;

        // If the position is close we can call the movement complete.
        if ((Math.floor(position.x) <= Math.floor(newPosX) + 15 &&
                Math.floor(position.x) >= Math.floor(newPosX) - 15) &&
            (Math.floor(position.z) <= Math.floor(newPosZ) + 15 &&
                Math.floor(position.z) >= Math.floor(newPosZ) - 15)) {
            position.x = Math.floor(position.x);
            position.z = Math.floor(position.z);

            // Reset any movements.
            this.clearTarget();

            // Maybe move should return a boolean. True if completed, false if not.
        }

        this.setPosition(position); //Update our position
    }
}